import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewItemComp  from "./Component/ViewItemComp"

const ViewItem =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewItemComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewItem